// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

export interface CommercialRulesDialogProps {
  dialogId: string;
  l10n?: ILocalization;
  routeStore: RouteStore;
  programName: string;
}

export const CommercialRulesDialog: React.FunctionComponent<CommercialRulesDialogProps> = ({
  dialogId,
  l10n,
  routeStore,
  programName,
}) => {
  const onDismiss = () => {
    routeStore.closeDialog();
  };

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogCommercialRules" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            <UitkDialogContent>
              <UitkHeading tag="h3" size={5}>
                <LocalizedText message={'programs.' + programName + '.commercial.rules.dialog.heading'} />
              </UitkHeading>
              <UitkSpacing margin={{ blockstart: 'six' }}>
                <div>
                  <UitkText spacing="three">
                    <LocalizedText message={'programs.' + programName + '.commercial.rules.dialog.content.1'} />
                  </UitkText>
                  <UitkText spacing="four">
                    <LocalizedText message={'programs.' + programName + '.commercial.rules.dialog.content.2'} />
                  </UitkText>
                  <UitkText spacing="four">
                    <LocalizedText message={'programs.' + programName + '.commercial.rules.dialog.content.3'} />
                  </UitkText>
                  <UitkText spacing="four">
                    <LocalizedText message={'programs.' + programName + '.commercial.rules.dialog.content.4'} />
                  </UitkText>
                </div>
              </UitkSpacing>
            </UitkDialogContent>
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={false}
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('close'),
                type: 'primary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  )
}
